<template>
  <PCSettingsBlock :title="t('userConfiguration.palletizingPoints.title')">
    <PCSettingsBlockItem :title="t('userConfiguration.palletizingPoints.order.title')">
      <template #right>
        <f7-button
          small
          popover-open=".popover-palletizing-points"
          class="button-order-text"
        >
          {{ currentOrderText }}
        </f7-button>
      </template>
    </PCSettingsBlockItem>

    <f7-popover
      v-model:opened="isOrderTypePopoverOpened"
      class="popover-palletizing-points"
    >
      <f7-list>
        <f7-list-item
          v-for="option in palletizingOptions"
          :key="option.value"
          :title="option.title"
          popover-close
          @click="orderField = option.value; isOrderTypePopoverOpened = false"
        />
      </f7-list>
    </f7-popover>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useSettingRef } from '@erpagroapp/settings';
import { useI18n } from 'vue-i18n';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const { t } = useI18n();
const orderField = useSettingRef('PuntosPaletizado.CampoOrdenacionPuntosPaletizado');

function useOrderType() {
  const palletizingOptions = /** @type {const} */ ([
    { title: t('userConfiguration.palletizingPoints.order.options.notApplied'), value: 'Id' },
    { title: t('userConfiguration.palletizingPoints.order.options.byCode'), value: 'Codigo' },
    { title: t('userConfiguration.palletizingPoints.order.options.byName'), value: 'Nombre' },
  ]);

  const isOrderTypePopoverOpened = ref(false);

  const currentOrderText = computed(
    () => palletizingOptions.find(
      (x) => x.value === orderField.value,
    )?.title || '',
  );

  return {
    palletizingOptions,
    isOrderTypePopoverOpened,
    currentOrderText,
  };
}

const {
  palletizingOptions,
  isOrderTypePopoverOpened,
  currentOrderText,
} = useOrderType();
</script>

<style scoped lang="scss">
.button-order-text {
  --f7-button-small-text-transform: initial;
}
</style>
